export const AVAILABLE_FLOW = 'available';
export const USER_FLOW = 'user';
export const ADD_TEXT = 'add';
export const OWNED_TEXT = 'owned';
